import React from "react";

import { Loader2 } from "lucide-react";

import { Card, CardContent } from "~/components/ui/card";

interface LoadingStateProps {
  message?: string;
}

const LoadingState: React.FC<LoadingStateProps> = ({
  message = "Cargando productos...",
}) => {
  return (
    <Card>
      <CardContent className="flex h-24 items-center justify-center pt-6">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <span className="ml-2">{message}</span>
      </CardContent>
    </Card>
  );
};

export default LoadingState;
